<div class="DatagridHeader__wrapper" role="rowgroup">
  <div
    class="DatagridHeader"
    [ngClass]="{ 't-bold': config?.isHeaderBold }"
    data-test-id="datagridHeader"
    role="row"
  >
    @if (config?.isSelectable) {
      <div
        class="DatagridHeader__cell DatagridHeader__cell--select"
        data-test-id="datagridHeaderColumn-0"
        role="columnheader"
      >
        <icon
          [name]="selectIcon"
          [config]="{
            type: 'pointer',
            fill: selectedRows.length > 0 ? 'primary' : 'text--1',
          }"
          (click)="toggleAllRows()"
        >
        </icon>
      </div>
    }

    <ng-template #selectionAction>
      <div class="DatagridHeader__selection">
        <div
          class="DatagridHeader__selection__action"
          (click)="selectionActionClicked.emit(selectedRows)"
          (keydown.enter)="selectionActionClicked.emit(selectedRows)"
        >
          <icon
            [name]="config.selectionAction.icon"
            [config]="{ type: 'link' }"
          >
          </icon>
          <p
            tabindex="0"
            class="DatagridHeader__selection__action__label"
            [innerHTML]="config.selectionAction.label"
          ></p>
        </div>

        <status
          class="DatagridHeader__selection__count"
          [config]="{
            hideBackground: config.hideStatusBackground,
            label: selectedRows.length + ' ' + rowsSelectedStatus,
          }"
          status="success"
        >
        </status>
      </div>
    </ng-template>

    @if (selectedRows.length === 0) {
      @for (column of config?.columns; track column; let i = $index) {
        <div
          class="DatagridHeader__cell DatagridHeader__cell--header"
          [ngClass]="{
            'DatagridHeader__cell--alignLeft': column.isLeftAligned,
            'DatagridHeader__cell--alignRight': column.isRightAligned,
            'DatagridHeader__cell--alignCenter':
              column.isCenterAligned ||
              (!column.isLeftAligned && !column.isRightAligned),
          }"
          [ngStyle]="{
            width: getColumnWidth(column),
            'min-width': getColumnWidth(column),
            'max-width': getColumnWidth(column),
          }"
          [attr.data-test-id]="'datagridHeaderColumn-' + i"
          role="columnheader"
        >
          @if (showHeaderLabel(column, formats, rows)) {
            @if (showHeaderLabel(column, formats, rows)) {
              <div
                (click)="handleColumnSortByClick($event, column)"
                (keydown.space)="handleColumnSortByClick($event, column)"
                [ngClass]="{ 'is-sortable': column.sortable }"
                class="DatagridHeader__cell--header__label"
                tabindex="0"
                [dataLoadEvent]="
                  digitalDataGridService.getDataLoadSortEvent(column)
                "
              >
                <p
                  class="DatagridHeader__CellHeaderValue"
                  [innerHTML]="column.label"
                ></p>
                @if (column.sortable) {
                  @if (column.sortable) {
                    <lib-sort-toggle
                      [isAscending]="
                        (column | datagridSortingState: sortOrder) ===
                        sortDirections.ASCENDING
                      "
                      [isDescending]="
                        (column | datagridSortingState: sortOrder) ===
                        sortDirections.DESCENDING
                      "
                    >
                    </lib-sort-toggle>
                  }
                }
              </div>
            }
          }
        </div>
      }
    } @else {
      <ng-container *ngTemplateOutlet="selectionAction"></ng-container>
    }
  </div>
</div>
